import React from 'react';

/** Underline tabs (e.g. 全部单集 / 会员专享 / 关于, or 节目笔记 / 对话字幕). */
export function Tabs({ items = [], activeId, onChange, className = '' }) {
  return (
    <div className={`bjl-tabs ${className}`} role="tablist">
      {items.map((it) => (
        <button
          key={it.id}
          role="tab"
          aria-selected={it.id === activeId}
          className={`bjl-tabs__item ${it.id === activeId ? 'is-active' : ''}`}
          onClick={() => onChange && onChange(it.id)}
        >
          {it.label}
          {it.count != null ? <span className="bjl-tabs__count">{it.count}</span> : null}
        </button>
      ))}
    </div>
  );
}
